import { Auth } from 'firebase/auth';

import { initChannel } from './auth-channel';
// Re-export from authentication.ts
import { clearAuth, initAuth } from './authentication';

// Re-export from logout-channel.ts
export { channelLogin, channelLogout } from './auth-channel';

// Initialize both authentication and logout channel
export const getAuthentication = async (): Promise<Auth> => {
  const auth = await initAuth();
  initChannel();
  return auth;
};

export const clearAuthentication = () => {
  clearAuth();
};
